import a from "next/script";
import { jsx as r } from "react/jsx-runtime";
const o = (t) => {
  const {
    gtmId: e
  } = t;
  return /* @__PURE__ */ r(a, {
    id: "google-tag-manager",
    strategy: "afterInteractive",
    children: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${e}');
      `
  });
}, i = (t) => {
  const {
    gtmId: e
  } = t;
  return /* @__PURE__ */ r("noscript", {
    children: /* @__PURE__ */ r("iframe", {
      height: "0",
      src: `https://www.googletagmanager.com/ns.html?id=${e}`,
      style: {
        display: "none",
        visibility: "hidden"
      },
      width: "0"
    })
  });
};
export {
  i as GoogleTagManagerIFrame,
  o as GoogleTagManagerScript
};
//# sourceMappingURL=GoogleTagManager.js.map
